// Single definition of "the mobile-dropdown bottom sheet will handle this tap".
//
// Two different notions of "mobile" coexist and must not be confused:
//   * isTouchPrimary() (select2_manager) — `(hover: none) and (pointer: coarse)`.
//     Decides whether Select2 is skipped in favour of the native control.
//   * isMobileSheetViewport() (here) — phone-sized AND touch-capable. Decides
//     whether mobile_dropdown_controller intercepts the tap and opens the sheet.
//
// A tablet satisfies the first but not the second, so it keeps the native inline
// list. Anything that collapses a control on the assumption the sheet will open
// it MUST gate on this predicate, not on touch alone.

export const MOBILE_SHEET_BREAKPOINT = 768

// True when the primary input is a coarse pointer that cannot hover — i.e. a
// real phone/tablet, not a touchscreen laptop (which also has a mouse). On those
// devices Select2's styled selection box is a non-interactive <span> that iOS
// will not open on tap, leaving the field dead, so callers can opt to fall back
// to the native control. Guarded for jsdom/SSR where matchMedia is absent
// (treated as non-touch).
export function isTouchPrimary() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false
  return window.matchMedia("(hover: none) and (pointer: coarse)").matches
}

export function isMobileSheetViewport(breakpoint = MOBILE_SHEET_BREAKPOINT) {
  if (typeof window === "undefined") return false
  if (window.innerWidth > breakpoint) return false

  return "ontouchstart" in window || navigator.maxTouchPoints > 0
}
